
export default {

    threat: 'Amenaza',
    threatMenu: 'Catálogo de amenazas',
    threats: 'Amenazas',
    newThreat: 'Agregar nueva amenaza',
    actor: 'Actor',
    actorPlaceHolder: 'Selecciona un efecto',
    noActor: 'Actor no encontrado',
    noActors: 'Actores no encontrados',
    reason: 'Motivo',
    reasonPlaceHolder: 'Selecciona un Motivo',
    noReason: 'Motivo no encontrado',
    noReasons: 'Motivos no encontrados',
    example: 'Ejemplo',
    code: 'Código',
    codePlaceHolder: 'Código de la amenaza',
    createThreat: 'Crear Amenaza',
    editLoader: 'Editando amenaza...',
    createLoader: 'Creando amenaza...',
    deleteThreatLoader: 'Eliminando amenaza...',
    getThreatsError: 'Ha ocurrido un error al obtener las amenazas: ',
    getThreatError: 'Ha ocurrido un error al consultar la amenaza: ',
    createThreatError: 'Ha ocurrido un error al crear la amenaza: ',
    editThreatError: 'Ha ocurrido un error al editar la amenaza: ',
    showhreatError: 'Ha ocurrido un error al consultar la amenaza: ',
    deleteThreatError: 'No ha sido posible eliminar la amenaza porque tiene activos o vulnerabilidades asociadas',
    createThreatSuccess: 'Amenaza creada exitosamente',
    editThreatSuccess: 'Amenaza actualizada exitosamente',
    deleteThreatSuccess: 'Amenaza eliminada exitosamente',
    noRegisteredThreats: 'Aún no tienes amenazas registradas',
    importThreatsFromCsv: 'Puedes importar amenazas desde un archivo CSV.',
    threatsGuide: 'El siguiente es un inventario de amenazas que pueden impactar los sistemas, puede agregar nuevas, puede asociarlas a los activos dentro del alcance y a las vulnerabilidades que puede explotar.',
    catalogThreats: 'Catálogo de Amenazas',
    saveThreat: 'Guardar amenaza',
    threatsGuideSettings: 'Administra el catálogo de amenazas del sistema e incorpora nuevas entradas dentro de este módulo.',


};
